export default __webpack_public_path__ + "static/media/effectiveness.f73fdefe.png";